import Vue from "vue";
import axios from "./axios";
import axios_v2 from "./axios_v2";
import Store from "@/store/store";
import router from "@/router";
import authService from "@/services/authService";

function setupInterceptors(instance) {
  instance.interceptors.request.use(config => {
    Vue.$log.debug("onRequest =", config);
    Vue.$log.info(Store.state.auth);
    Vue.$log.debug("ID Token = ", Store.state.auth.idToken);
    config.headers["id_token"] = Store.state.auth.idToken;
    return config;
  });

  instance.interceptors.response.use(
    response => {
      Vue.$log.debug("onResponse =", response.data);
      return Promise.resolve({
        status: true,
        data: response.data,
      });
    },
    error => {
      Vue.$log.error("onResponse =", error);
      const isRetry = error.config.headers["is_retry"];
      if (error.response.status === 403 && !isRetry) {
        const isUpdatingToken = Store.getters["auth/isUpdatingToken"];
        if (isUpdatingToken) {
          const unSubscribe = Store.subscribe(mutation => {
            if (mutation.type === "auth/FINISH_REFRESH_TOKEN") {
              setTimeout(unSubscribe);
              error.config.headers["id_token"] = Store.state.auth.idToken;
              error.config.headers["is_retry"] = true;
              return instance.request(error.config);
            }
          });
        } else {
          const requestSymbol = Symbol();
          Store.commit("auth/START_REFRESH_TOKEN", requestSymbol);
          return authService.renewToken(true).then(res => {
            Store.commit("auth/FINISH_REFRESH_TOKEN", requestSymbol);
            if (res) {
              error.config.headers["id_token"] = Store.state.auth.idToken;
              error.config.headers["is_retry"] = true;
              return instance.request(error.config);
            } else {
              Store.dispatch("auth/cleanupLocalData");
              router.push({
                name: "login-enterprise",
                query: { logout: "force" },
              });
              return Promise.resolve({
                status: false,
                data: error.response.data,
              });
            }
          });
        }
      }

      return Promise.resolve({
        status: false,
        code: error.response.status,
        data: error.response.data,
        message: error.response.data.message,
      });
    }
  );
}

export default {
  init() {
    setupInterceptors(axios);
    setupInterceptors(axios_v2);
  },
};
